/* Lumenti v4 (23.10): filtry w panelu bocznym od razu rozwinięte na komputerze (także po przeładowaniu wyników), aktywny chip kategorii widoczny na telefonie. */
(function () {
  var desktop = window.matchMedia('(min-width: 750px)');
  function openAll(root) {
    if (!desktop.matches) return;
    (root || document).querySelectorAll('.facets--vertical details.facets__panel:not([open])').forEach(function (d) {
      d.setAttribute('open', '');
    });
  }
  function showActive() {
    document.querySelectorAll('.nx-seo__chips').forEach(function (row) {
      var a = row.querySelector('[aria-current="page"]');
      if (a && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, a.offsetLeft - row.offsetLeft - 18);
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    showActive();
    openAll();
    new MutationObserver(function () { openAll(); }).observe(document.body, { childList: true, subtree: true });
  });
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.facets--vertical details.facets__panel > summary');
    if (s && desktop.matches) e.preventDefault();
  }, true);
})();
